export default "<p>cart-menu-popover works!</p>\n";